import { Helmet as ReactHelmet } from 'react-helmet';

const Helmet = () => {
  const env = process.env.SNOWIT_ENVIRONMENT || 'development';
  const baseTitle = 'Pannello Admin | Sportit';
  const title = env === 'production' ? baseTitle : `[DEV] ${baseTitle}`;
  return (
    <ReactHelmet>
      <title>{title}</title>
      <link rel='apple-touch-icon' sizes='180x180' href={`/favicon/${env}/apple-touch-icon.png`} />
      <link rel='icon' type='image/png' sizes='32x32' href={`/favicon/${env}/favicon-32x32.png`} />
      <link rel='icon' type='image/png' sizes='16x16' href={`/favicon/${env}/favicon-16x16.png`} />
      <link rel='manifest' href={`/favicon/${env}/site.webmanifest`} />
      <link rel='mask-icon' href={`/favicon/${env}/safari-pinned-tab.svg`} color='#5bbad5' />
    </ReactHelmet>
  );
};

export default Helmet;
